import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import html2pdf from "html2pdf.js";
import SideBar from "../../../components/b2b/SideBar";
import Header from "../../../components/landingPage/Header";
import { DownloadIcon } from "@heroicons/react/solid";

const Voucher = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const { bookingDetailsById } = useSelector((state) => state.booking);
  const { allCompany } = useSelector((state) => state.company);
  const { settings } = useSelector((state) => state.settings);
  const { token } = useSelector((state) => state.auth);
  const [company, setcompany] = useState();

  useEffect(() => {
    dispatch({
      type: "GET_ALL_COMPANY",
      payload: { token },
    });
  }, []);

  useEffect(() => {
    dispatch({ type: "GET_BOOKING_DETAILS_BY_ID", payload: { id: id } });
  }, [dispatch, id]);

  useEffect(() => {
    allCompany?.map((company) => {
      return company?.users?.map((user) => {
        return (
          user?.userName === bookingDetailsById?.userName?.split(" ")[0] &&
          setcompany(company)
        );
      });
    });
  }, [allCompany, bookingDetailsById?.userName]);

  const downloadInvoice = () => {
    const input = document.getElementById("voucher");
    // html2canvas(input, {}).then((canvas) => {
    //   const imgData = canvas.toDataURL("image/png");
    //   const pdf = new jsPDF("p", "pt", "a4");
    //   pdf.addImage(imgData, "PNG", 30, 5, 550, 820);
    //   // setInvoice_attachment(pdf.output("Voucher.pdf"));
    //   pdf.save("invoice.pdf");
    // });
    html2pdf()
      .set({
        margin: 1,
        filename: "voucher.pdf",
        image: { type: "jpeg", quality: 0.2 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: "in", format: "a4", orientation: "p" },
      })
      .from(input)
      .save("voucher.pdf");
  };

  return (
    <div className="w-screen fixed">
      <Header token={token} />
      <div className="flex">
        <SideBar />
        <div className="overflow-y-auto h-[90vh] scrollbar-hide md:ml-16">
          <div id="bookingStatus">
            <div>
              <table
                id="voucher"
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                // className="max-w-[700px] p-4"
              >
                <thead>
                  <tr>
                    <td bgcolor="#ffffff" align="left" className="wrapper">
                      <table
                        border="0"
                        cellpadding="0"
                        cellspacing="0"
                        width="100%"
                        // className="pb-2 border-b"
                      >
                        <tr>
                          <td align="center" valign="top" width="40%">
                            <img
                              alt="Logo"
                              src={company?.companyLogo?.secure_url}
                              width="200"
                              height="108"
                              className=" "
                              border="0"
                            />
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td bgcolor="#ffffff" align="left" className="wrapper">
                      <table
                        border="0"
                        cellpadding="0"
                        cellspacing="0"
                        width="100%"
                        className="max-w-[700px] responsive-table mb-6"
                      >
                        <tr>
                          <td>
                            <table
                              width="100%"
                              border="0"
                              cellspacing="0"
                              cellpadding="0"
                            >
                              <tr>
                                <td className="pt-5 pl-3 font-sans text-[14px] font-normal text-left text-black">
                                  Dear{" "}
                                  {
                                    bookingDetailsById?.passengerDetails
                                      ?.firstName
                                  }
                                  ,
                                </td>
                              </tr>
                              <tr>
                                <td className="py-5 px-3 font-sans text-[14px] text-left text-black bold">
                                  Thank you for booking with{" "}
                                  {company?.companyName}. You will receive
                                  driver details atleast 1 hour prior to pick up
                                  time. You can find the summary of your booking
                                  below.
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>

                  <tr>
                    <td
                      bgcolor="#ffffff"
                      align="left"
                      className="padding wrapper"
                    >
                      <table
                        cellpadding="0"
                        cellspacing="0"
                        width="100%"
                        className="max-w-[700px] border bg-[#fafafa]"
                      >
                        <tr>
                          <td>
                            <table
                              cellspacing="0"
                              cellpadding="0"
                              width="100%"
                              className="bg-[#e6e6e6]"
                            >
                              <tr>
                                <td
                                  valign="top"
                                  className="pt-0.5 pb-3.5 pl-3 mobile-wrapper"
                                >
                                  <table
                                    cellpadding="0"
                                    cellspacing="0"
                                    border="0"
                                    width="100%"
                                    className="w-full text-left"
                                  >
                                    <tr>
                                      <td>
                                        <table
                                          cellpadding="0"
                                          cellspacing="0"
                                          border="0"
                                          width="100%"
                                        >
                                          <tr>
                                            <td
                                              align="left"
                                              className="text-black text-[14px] font-semibold"
                                            >
                                              BOOKING DETAILS
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <table
                              cellspacing="0"
                              cellpadding="0"
                              border="0"
                              width="100%"
                            >
                              <tr>
                                <td
                                  valign="top"
                                  className="flex mobile-wrapper mt-2"
                                >
                                  <table
                                    cellpadding="0"
                                    cellspacing="0"
                                    border="0"
                                    className="w-[35%] ml-3 text-left"
                                    width="35%"
                                  >
                                    <tr>
                                      <td className="pb-1">
                                        <table
                                          cellpadding="0"
                                          cellspacing="0"
                                          border="0"
                                          width="100%"
                                        >
                                          <tr>
                                            <td
                                              align="left"
                                              className="font-sans text-black text-[13px] "
                                            >
                                              <b>Booking ID:</b>
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>

                                  <table
                                    cellpadding="0"
                                    cellspacing="0"
                                    border="0"
                                    width="60%"
                                    className="w-3/5 text-left"
                                  >
                                    <tr>
                                      <td className="pb-1">
                                        <table
                                          cellpadding="0"
                                          cellspacing="0"
                                          border="0"
                                          width="100%"
                                        >
                                          <tr>
                                            <td
                                              align="left"
                                              className="font-sans text-black text-left text-[13px]"
                                            >
                                              {bookingDetailsById?.bookingId}
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <table
                              cellspacing="0"
                              cellpadding="0"
                              border="0"
                              width="100%"
                            >
                              <tr>
                                <td valign="top" className="p-0 mobile-wrapper">
                                  <table
                                    cellpadding="0"
                                    cellspacing="0"
                                    border="0"
                                    width="35%"
                                    className="w-[35%] ml-3 text-left"
                                    align="left"
                                  >
                                    <tr>
                                      <td className="pb-1">
                                        <table
                                          cellpadding="0"
                                          cellspacing="0"
                                          border="0"
                                          width="100%"
                                        >
                                          <tr>
                                            <td
                                              align="left"
                                              className="font-sans text-black text-[13px]"
                                            >
                                              <b>Pickup Date and Time:</b>
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>

                                  <table
                                    cellpadding="0"
                                    cellspacing="0"
                                    border="0"
                                    width="60%"
                                    className="w-3/5 text-left"
                                    align="left"
                                  >
                                    <tr>
                                      <td>
                                        <table
                                          cellpadding="0"
                                          cellspacing="0"
                                          border="0"
                                          width="100%"
                                        >
                                          <tr>
                                            <td
                                              align="left"
                                              className="font-sans text-black text-[13px] text-left"
                                            >
                                              {moment(
                                                bookingDetailsById.travelDate?.split(
                                                  "T"
                                                )[0]
                                              ).format("MMMM Do YYYY")}{" "}
                                              at {bookingDetailsById.travelTime}
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <table
                              cellspacing="0"
                              cellpadding="0"
                              border="0"
                              width="100%"
                            >
                              <tr>
                                <td valign="top" className="p-0 mobile-wrapper">
                                  <table
                                    cellpadding="0"
                                    cellspacing="0"
                                    border="0"
                                    width="35%"
                                    className="w-[35%] ml-3 text-left"
                                    align="left"
                                  >
                                    <tr>
                                      <td>
                                        <table
                                          cellpadding="0"
                                          cellspacing="0"
                                          border="0"
                                          width="100%"
                                        >
                                          <tr>
                                            <td
                                              align="left"
                                              className="font-sans text-black text-[13px]"
                                            >
                                              <b>Pickup:</b>
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>

                                  <table
                                    cellpadding="0"
                                    cellspacing="0"
                                    border="0"
                                    width="60%"
                                    className="w-3/5 text-left"
                                    align="left"
                                  >
                                    <tr>
                                      <td className="pr-3">
                                        <table
                                          cellpadding="0"
                                          cellspacing="0"
                                          border="0"
                                          width="100%"
                                        >
                                          <tr>
                                            <td
                                              align="left"
                                              className="font-sans text-black text-[13px]"
                                            >
                                              {
                                                bookingDetailsById?.source
                                                  ?.placename
                                              }
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            {bookingDetailsById?.destination?.placename && (
                              <table
                                cellspacing="0"
                                cellpadding="0"
                                border="0"
                                width="100%"
                              >
                                <tr>
                                  <td
                                    valign="top"
                                    className="p-0 mobile-wrapper"
                                  >
                                    <table
                                      cellpadding="0"
                                      cellspacing="0"
                                      border="0"
                                      width="35%"
                                      className="w-[35%] ml-3 text-left"
                                      align="left"
                                    >
                                      <tr>
                                        <td className="pb-1">
                                          <table
                                            cellpadding="0"
                                            cellspacing="0"
                                            border="0"
                                            width="100%"
                                          >
                                            <tr>
                                              <td
                                                align="left"
                                                className="font-sans text-black text-[13px]"
                                              >
                                                <b>Drop off:</b>
                                              </td>
                                            </tr>
                                          </table>
                                        </td>
                                      </tr>
                                    </table>

                                    <table
                                      cellpadding="0"
                                      cellspacing="0"
                                      border="0"
                                      width="60%"
                                      className="w-3/5 text-left"
                                      align="left"
                                    >
                                      <tr>
                                        <td>
                                          <table
                                            cellpadding="0"
                                            cellspacing="0"
                                            border="0"
                                            width="100%"
                                          >
                                            <tr>
                                              <td
                                                align="left"
                                                className="font-sans text-black text-[13px] text-left"
                                              >
                                                {
                                                  bookingDetailsById
                                                    ?.destination?.placename
                                                }
                                              </td>
                                            </tr>
                                          </table>
                                        </td>
                                      </tr>
                                    </table>
                                  </td>
                                </tr>
                              </table>
                            )}
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <table
                              cellspacing="0"
                              cellpadding="0"
                              border="0"
                              width="100%"
                            >
                              <tr>
                                <td valign="top" className="p-0 mobile-wrapper">
                                  <table
                                    cellpadding="0"
                                    cellspacing="0"
                                    border="0"
                                    width="35%"
                                    className="w-[35%] ml-3 text-left"
                                    align="left"
                                  >
                                    <tr>
                                      <td className="pb-1">
                                        <table
                                          cellpadding="0"
                                          cellspacing="0"
                                          border="0"
                                          width="100%"
                                        >
                                          <tr>
                                            <td
                                              align="left"
                                              className="font-sans text-black text-[13px]"
                                            >
                                              <b>Booking Type:</b>
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>

                                  <table
                                    cellpadding="0"
                                    cellspacing="0"
                                    border="0"
                                    width="60%"
                                    className="w-3/5 text-left"
                                    align="left"
                                  >
                                    <tr>
                                      <td>
                                        <table
                                          cellpadding="0"
                                          cellspacing="0"
                                          border="0"
                                          width="100%"
                                        >
                                          <tr>
                                            <td
                                              align="left"
                                              className="font-sans text-black text-[13px] text-left"
                                            >
                                              {bookingDetailsById?.bookingType
                                                ?.charAt(0)
                                                ?.toUpperCase() +
                                                bookingDetailsById?.bookingType
                                                  ?.slice(1)
                                                  .toLowerCase()}
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <table
                              cellspacing="0"
                              cellpadding="0"
                              border="0"
                              width="100%"
                            >
                              <tr>
                                <td valign="top" className="p-0 mobile-wrapper">
                                  <table
                                    cellpadding="0"
                                    cellspacing="0"
                                    border="0"
                                    width="35%"
                                    className="w-[35%] ml-3 text-left"
                                    align="left"
                                  >
                                    <tr>
                                      <td className="pb-1">
                                        <table
                                          cellpadding="0"
                                          cellspacing="0"
                                          border="0"
                                          width="100%"
                                        >
                                          <tr>
                                            <td
                                              align="left"
                                              className="font-sans text-black text-[13px]"
                                            >
                                              <b>Booking Status:</b>
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>

                                  <table
                                    cellpadding="0"
                                    cellspacing="0"
                                    border="0"
                                    width="60%"
                                    className="w-3/5 text-left"
                                    align="left"
                                  >
                                    <tr>
                                      <td>
                                        <table
                                          cellpadding="0"
                                          cellspacing="0"
                                          border="0"
                                          width="100%"
                                        >
                                          <tr>
                                            <td
                                              align="left"
                                              className="font-sans text-black text-[13px] text-left"
                                            >
                                              {
                                                bookingDetailsById?.bookingStatus
                                              }
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <table
                              cellspacing="0"
                              cellpadding="0"
                              border="0"
                              width="100%"
                            >
                              <tr>
                                <td valign="top" className="p-0 mobile-wrapper">
                                  <table
                                    cellpadding="0"
                                    cellspacing="0"
                                    border="0"
                                    width="35%"
                                    className="w-[35%] ml-3 text-left"
                                    align="left"
                                  >
                                    <tr>
                                      <td className="pb-1">
                                        <table
                                          cellpadding="0"
                                          cellspacing="0"
                                          border="0"
                                          width="100%"
                                        >
                                          <tr>
                                            <td
                                              align="left"
                                              className="font-sans text-black text-[13px]"
                                            >
                                              <b>Distance / Duration:</b>
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>

                                  <table
                                    cellpadding="0"
                                    cellspacing="0"
                                    border="0"
                                    width="60%"
                                    className="w-3/5 text-left"
                                    align="left"
                                  >
                                    <tr>
                                      <td>
                                        <table
                                          cellpadding="0"
                                          cellspacing="0"
                                          border="0"
                                          width="100%"
                                        >
                                          <tr>
                                            {(bookingDetailsById.duration ||
                                              bookingDetailsById.travelDistance) && (
                                              <td
                                                align="left"
                                                className="font-sans text-black text-[13px] text-left"
                                              >
                                                {Math.round(
                                                  bookingDetailsById.travelDistance
                                                )}{" "}
                                                km /{" "}
                                                {bookingDetailsById.duration}{" "}
                                                hrs
                                              </td>
                                            )}
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <table
                              cellspacing="0"
                              cellpadding="0"
                              border="0"
                              width="100%"
                            >
                              <tr>
                                <td valign="top" className="p-0 mobile-wrapper">
                                  <table
                                    cellpadding="0"
                                    cellspacing="0"
                                    border="0"
                                    width="35%"
                                    className="w-[35%] ml-3 text-left"
                                    align="left"
                                  >
                                    <tr>
                                      <td className="pb-1">
                                        <table
                                          cellpadding="0"
                                          cellspacing="0"
                                          border="0"
                                          width="100%"
                                        >
                                          <tr>
                                            <td
                                              align="left"
                                              className="font-sans text-black text-[13px]"
                                            >
                                              <b>Flight/Train Number:</b>
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>

                                  <table
                                    cellpadding="0"
                                    cellspacing="0"
                                    border="0"
                                    width="60%"
                                    className="w-3/5 text-left"
                                    align="left"
                                  >
                                    <tr>
                                      <td>
                                        <table
                                          cellpadding="0"
                                          cellspacing="0"
                                          border="0"
                                          width="100%"
                                        >
                                          <tr>
                                            <td
                                              align="left"
                                              className="font-sans text-black text-[13px] text-left"
                                            >
                                              {
                                                bookingDetailsById
                                                  ?.passengerDetails
                                                  ?.flightNumber
                                              }
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <table
                              cellspacing="0"
                              cellpadding="0"
                              border="0"
                              width="100%"
                            >
                              <tr>
                                <td valign="top" className="p-0 mobile-wrapper">
                                  <table
                                    cellpadding="0"
                                    cellspacing="0"
                                    border="0"
                                    width="35%"
                                    className="w-[35%] ml-3 text-left"
                                    align="left"
                                  >
                                    <tr>
                                      <td className="pb-3">
                                        <table
                                          cellpadding="0"
                                          cellspacing="0"
                                          border="0"
                                          width="100%"
                                        >
                                          <tr>
                                            <td
                                              align="left"
                                              className="font-sans text-black text-[13px]"
                                            >
                                              <b>Special Request:</b>
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>

                                  <table
                                    cellpadding="0"
                                    cellspacing="0"
                                    border="0"
                                    width="60%"
                                    className="w-3/5 text-left"
                                    align="left"
                                  >
                                    <tr>
                                      <td className="pb-4 pr-3">
                                        <table
                                          cellpadding="0"
                                          cellspacing="0"
                                          border="0"
                                          width="100%"
                                        >
                                          <tr>
                                            <td
                                              align="left"
                                              className="font-sans text-black text-[13px]"
                                            >
                                              {bookingDetailsById
                                                ?.passengerDetails
                                                ?.specialRequest
                                                ? bookingDetailsById
                                                    ?.passengerDetails
                                                    ?.specialRequest
                                                : ""}
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>

                  <tr>
                    <td
                      bgcolor="#ffffff"
                      align="left"
                      className="padding wrapper"
                    >
                      <table
                        cellpadding="0"
                        cellspacing="0"
                        width="100%"
                        className="max-w-[700px] border bg-[#fafafa]"
                      >
                        <tr>
                          <td>
                            <table
                              cellspacing="0"
                              cellpadding="0"
                              width="100%"
                              className="bg-[#e6e6e6]"
                            >
                              <tr>
                                <td
                                  valign="top"
                                  className="pt-0.5 pb-3.5 pl-3 mobile-wrapper"
                                >
                                  <table
                                    cellpadding="0"
                                    cellspacing="0"
                                    border="0"
                                    width="100%"
                                    className="w-full text-left"
                                  >
                                    <tr>
                                      <td>
                                        <table
                                          cellpadding="0"
                                          cellspacing="0"
                                          border="0"
                                          width="100%"
                                        >
                                          <tr>
                                            <td
                                              align="left"
                                              className="text-black text-[14px] font-semibold"
                                            >
                                              CAR DETAILS
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <table
                              cellspacing="0"
                              cellpadding="0"
                              border="0"
                              width="100%"
                            >
                              <tr>
                                <td
                                  valign="top"
                                  className="flex mobile-wrapper "
                                >
                                  <table
                                    cellpadding="0"
                                    cellspacing="0"
                                    border="0"
                                    className="w-[35%] ml-3 text-left"
                                    width="35%"
                                  >
                                    <tr>
                                      <td className="pt-2 pb-4">
                                        <table
                                          cellpadding="0"
                                          cellspacing="0"
                                          border="0"
                                          width="100%"
                                        >
                                          <tr>
                                            <td
                                              align="left"
                                              className="font-sans text-black text-[13px] "
                                            >
                                              <b>Vehicle Type:</b>
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>

                                  <table
                                    cellpadding="0"
                                    cellspacing="0"
                                    border="0"
                                    width="60%"
                                    className="w-3/5 text-left"
                                  >
                                    <tr>
                                      <td className="pt-2 pb-4 pr-3">
                                        <table
                                          cellpadding="0"
                                          cellspacing="0"
                                          border="0"
                                          width="100%"
                                        >
                                          <tr>
                                            <td
                                              align="left"
                                              className="font-sans text-black text-left text-[13px]"
                                            >
                                              {
                                                bookingDetailsById
                                                  ?.vehicleDetails?.categoryType
                                              }
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>

                  <tr>
                    <td
                      bgcolor="#ffffff"
                      align="left"
                      className="padding wrapper"
                    >
                      <table
                        cellpadding="0"
                        cellspacing="0"
                        width="100%"
                        className="max-w-[700px] border bg-[#fafafa]"
                      >
                        <tr>
                          <td>
                            <table
                              cellspacing="0"
                              cellpadding="0"
                              width="100%"
                              className="bg-[#e6e6e6]"
                            >
                              <tr>
                                <td
                                  valign="top"
                                  className="pt-0.5 pb-3.5 pl-3 mobile-wrapper"
                                >
                                  <table
                                    cellpadding="0"
                                    cellspacing="0"
                                    border="0"
                                    width="100%"
                                    className="w-full text-left"
                                  >
                                    <tr>
                                      <td>
                                        <table
                                          cellpadding="0"
                                          cellspacing="0"
                                          border="0"
                                          width="100%"
                                        >
                                          <tr>
                                            <td
                                              align="left"
                                              className="text-black text-[14px] font-semibold"
                                            >
                                              PASSENGER DETAILS
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <table
                              cellspacing="0"
                              cellpadding="0"
                              border="0"
                              width="100%"
                            >
                              <tr>
                                <td
                                  valign="top"
                                  className="flex mobile-wrapper py-1"
                                >
                                  <table
                                    cellpadding="0"
                                    cellspacing="0"
                                    border="0"
                                    className="w-[35%] ml-3 text-left"
                                    width="35%"
                                  >
                                    <tr>
                                      <td className="pb-1">
                                        <table
                                          cellpadding="0"
                                          cellspacing="0"
                                          border="0"
                                          width="100%"
                                        >
                                          <tr>
                                            <td
                                              align="left"
                                              className="font-sans text-black text-[13px] "
                                            >
                                              <b>Name:</b>
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>

                                  <table
                                    cellpadding="0"
                                    cellspacing="0"
                                    border="0"
                                    width="60%"
                                    className="w-3/5 text-left"
                                  >
                                    <tr>
                                      <td>
                                        <table
                                          cellpadding="0"
                                          cellspacing="0"
                                          border="0"
                                          width="100%"
                                        >
                                          <tr>
                                            <td
                                              align="left"
                                              className="font-sans text-black text-left text-[13px]"
                                            >
                                              {
                                                bookingDetailsById
                                                  ?.passengerDetails?.firstName
                                              }{" "}
                                              {
                                                bookingDetailsById
                                                  ?.passengerDetails?.lastName
                                              }
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <table
                              cellspacing="0"
                              cellpadding="0"
                              border="0"
                              width="100%"
                            >
                              <tr>
                                <td
                                  valign="top"
                                  className="flex mobile-wrapper py-1"
                                >
                                  <table
                                    cellpadding="0"
                                    cellspacing="0"
                                    border="0"
                                    className="w-[35%] ml-3 text-left"
                                    width="35%"
                                  >
                                    <tr>
                                      <td className="pb-1">
                                        <table
                                          cellpadding="0"
                                          cellspacing="0"
                                          border="0"
                                          width="100%"
                                        >
                                          <tr>
                                            <td
                                              align="left"
                                              className="font-sans text-black text-[13px] "
                                            >
                                              <b>Mobile:</b>
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>

                                  <table
                                    cellpadding="0"
                                    cellspacing="0"
                                    border="0"
                                    width="60%"
                                    className="w-3/5 text-left"
                                  >
                                    <tr>
                                      <td>
                                        <table
                                          cellpadding="0"
                                          cellspacing="0"
                                          border="0"
                                          width="100%"
                                        >
                                          <tr>
                                            <td
                                              align="left"
                                              className="font-sans text-black text-left text-[13px]"
                                            >
                                              {
                                                bookingDetailsById
                                                  ?.passengerDetails?.dial_code
                                              }{" "}
                                              {
                                                bookingDetailsById
                                                  ?.passengerDetails?.phone
                                              }
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <table
                              cellspacing="0"
                              cellpadding="0"
                              border="0"
                              width="100%"
                            >
                              <tr>
                                <td
                                  valign="top"
                                  className="flex mobile-wrapper"
                                >
                                  <table
                                    cellpadding="0"
                                    cellspacing="0"
                                    border="0"
                                    className="w-[35%] ml-3 text-left"
                                    width="35%"
                                  >
                                    <tr>
                                      <td>
                                        <table
                                          cellpadding="0"
                                          cellspacing="0"
                                          border="0"
                                          width="100%"
                                        >
                                          <tr>
                                            <td
                                              align="left"
                                              className="font-sans text-black text-[13px] "
                                            >
                                              <b>Email:</b>
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>

                                  <table
                                    cellpadding="0"
                                    cellspacing="0"
                                    border="0"
                                    width="60%"
                                    className="w-3/5 text-left"
                                  >
                                    <tr>
                                      <td>
                                        <table
                                          cellpadding="0"
                                          cellspacing="0"
                                          border="0"
                                          width="100%"
                                        >
                                          <tr>
                                            <td
                                              align="left"
                                              className="font-sans text-black text-left text-[13px]"
                                            >
                                              {
                                                bookingDetailsById
                                                  ?.passengerDetails?.email
                                              }
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <table
                              cellspacing="0"
                              cellpadding="0"
                              border="0"
                              width="100%"
                            >
                              <tr>
                                <td
                                  valign="top"
                                  className="flex mobile-wrapper py-1"
                                >
                                  <table
                                    cellpadding="0"
                                    cellspacing="0"
                                    border="0"
                                    className="w-[35%] ml-3 text-left"
                                    width="35%"
                                  >
                                    <tr>
                                      <td className="pb-3">
                                        <table
                                          cellpadding="0"
                                          cellspacing="0"
                                          border="0"
                                          width="100%"
                                        >
                                          <tr>
                                            <td
                                              align="left"
                                              className="font-sans text-black text-[13px] "
                                            >
                                              <b>No. of Pax:</b>
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>

                                  <table
                                    cellpadding="0"
                                    cellspacing="0"
                                    border="0"
                                    width="60%"
                                    className="w-3/5 text-left"
                                  >
                                    <tr>
                                      <td className="pb-4">
                                        <table
                                          cellpadding="0"
                                          cellspacing="0"
                                          border="0"
                                          width="100%"
                                        >
                                          <tr>
                                            <td
                                              align="left"
                                              className="font-sans text-black text-left text-[13px]"
                                            >
                                              {bookingDetailsById?.passenger}
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>

                  <tr>
                    <td
                      bgcolor="#ffffff"
                      align="left"
                      className="padding wrapper"
                    >
                      <table
                        cellpadding="0"
                        cellspacing="0"
                        width="100%"
                        className="max-w-[700px] border bg-[#fafafa]"
                      >
                        <tr>
                          <td>
                            <table
                              cellspacing="0"
                              cellpadding="0"
                              width="100%"
                              className="bg-[#e6e6e6]"
                            >
                              <tr>
                                <td
                                  valign="top"
                                  className="pt-0.5 pb-3.5 pl-3 mobile-wrapper"
                                >
                                  <table
                                    cellpadding="0"
                                    cellspacing="0"
                                    border="0"
                                    width="100%"
                                    className="w-full text-left"
                                  >
                                    <tr>
                                      <td>
                                        <table
                                          cellpadding="0"
                                          cellspacing="0"
                                          border="0"
                                          width="100%"
                                        >
                                          <tr>
                                            <td
                                              align="left"
                                              className="text-black text-[12px] font-semibold"
                                            >
                                              EMERGENCY CONTACT DETAILS
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <table
                              cellspacing="0"
                              cellpadding="0"
                              border="0"
                              width="100%"
                            >
                              <tr>
                                <td
                                  valign="top"
                                  className="flex mobile-wrapper py-1"
                                >
                                  <table
                                    cellpadding="0"
                                    cellspacing="0"
                                    border="0"
                                    className="w-[35%] ml-3 text-left"
                                    width="35%"
                                  >
                                    <tr>
                                      <td className="pt-2 pb-4">
                                        <table
                                          cellpadding="0"
                                          cellspacing="0"
                                          border="0"
                                          width="100%"
                                        >
                                          <tr>
                                            <td
                                              align="left"
                                              className="font-sans text-black text-[13px] "
                                            >
                                              <b>Emergency Contact No.:</b>
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>

                                  <table
                                    cellpadding="0"
                                    cellspacing="0"
                                    border="0"
                                    width="60%"
                                    className="w-3/5 text-left"
                                  >
                                    <tr>
                                      <td className="pt-1 pb-2">
                                        <table
                                          cellpadding="0"
                                          cellspacing="0"
                                          border="0"
                                          width="100%"
                                        >
                                          <tr>
                                            <td
                                              align="left"
                                              className="font-sans text-black text-left text-[11px]  "
                                            >
                                              <td>
                                                {settings?.emergencyContact1},
                                              </td>
                                              <td
                                                style={{
                                                  padding: "0 10px",
                                                }}
                                              >
                                                {settings?.emergencyContact2},
                                              </td>
                                              <td>
                                                {settings?.emergencyContact3}
                                              </td>
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>

                  <tr>
                    <td className="px-3 py-3">
                      <table
                        width="100%"
                        border="0"
                        cellspacing="0"
                        cellpadding="0"
                      >
                        <tr>
                          <td
                            align="left"
                            className="p-0 font-sans text-[12px] text-black padding-copy"
                          >
                            **1. All prices include statutory taxes, if
                            applicable.
                          </td>
                        </tr>
                        <tr>
                          <td
                            align="left"
                            className="p-0 font-sans text-[12px] text-black padding-copy"
                          >
                            2. Free cancellation upto 24 hours or as per given
                            by us over email for offline bookings before pickup
                            time.
                          </td>
                        </tr>
                        <tr>
                          <td
                            align="left"
                            className="p-0 font-sans text-[12px] text-black padding-copy"
                          >
                            3. Free 60 minutes waiting time after flight landing
                            for airport pickup, 15 minutes waiting time for all
                            other pickups.
                          </td>
                        </tr>
                        <tr>
                          <td
                            align="left"
                            className="p-0 font-sans text-[12px] text-black padding-copy"
                          >
                            4. Flight No./Train No. is mandatory for
                            airport/station pick up and drop off.
                          </td>
                        </tr>
                        <tr>
                          <td
                            align="left"
                            className="pt-6 font-sans text-[12px] text-black padding-copy"
                          >
                            Best Regards,
                          </td>
                        </tr>
                        <tr>
                          <td
                            align="left"
                            className="p-0 font-sans text-[12px] text-black padding-copy"
                          >
                            Your {company?.companyName} Team
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>

                  <tr>
                    <td className="px-3 py-3">
                      <table
                        width="100%"
                        border="0"
                        cellspacing="0"
                        cellpadding="0"
                      >
                        <tr>
                          <td
                            align="left"
                            className="p-0 text-[10px] italic text-gray-600 padding-copy"
                          >
                            <span className="font-semibold">DISCLAIMER:</span>
                            <br />
                            This e-mail contains PRIVILEGED AND CONFIDENTIAL
                            INFORMATION intended solely for the use of the
                            addressee(s). If you are not the intended recipient,
                            please notify the sender by e-mail and delete the
                            original message. Further, you are not to copy,
                            disclose, or distribute this e-mail or its contents
                            to any other person and any such actions are
                            unlawful. This e-mail may contain viruses.{" "}
                            {company?.companyName} has taken every reasonable
                            precaution to minimize this risk, but is not liable
                            for any damage you may sustain as a result of any
                            virus in this e-mail. You should carry out your own
                            virus checks before opening the e-mail or
                            attachment. {company?.companyName} reserves the
                            right to monitor and review the content of all
                            messages sent to or from this e-mail address.
                            Messages sent to or from this e-mail address may be
                            stored on the {company?.companyName} e-mail system.
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="flex justify-center mt-5 space-x-2">
              <div
                onClick={downloadInvoice}
                className="flex space-x-1 bg-secondary  text-white cursor-pointer hover:bg-gray-300 hover:text-black px-2 py-1 rounded-sm"
              >
                <DownloadIcon className="w-5 text-center" />

                <div className="text-sm font-medium">Download</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Voucher;
